<template>
  <cv-file-uploader
    :accept="accept"
    class="ff-input"
    :class="{
      'is-secondary': type === 2,
      'is-file': accept === '*',
      'is-menu': menu,
    }"
    @input="action"
    :drop-target-label="text"/>
</template>

<script>
export default {
  name: 'ff-file-upload',
  props: [
    'action',
    'accept',
    'text',
    'type',
    'menu'
  ],
  data () {
    return {
    }
  },
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";

  .ff-input {
    font-size: $fontSize-normal;
    margin-bottom: 0;
    justify-content: space-evenly;

    &:hover {
      ::v-deep .bx--file__drop-container {
        text-decoration: none;
      }
    }
  }

  ::v-deep .bx--file-browse-btn {
    color: $color-dark;
    outline: 0;
    margin: 0;

    &:hover {
      color: $color-main;
      outline: 0;
    }
  }

  ::v-deep .bx--file-container {
    display: none;
  }

  ::v-deep .bx--file__drop-container {
    align-items: center;
    justify-content: center;
    border-radius: $borderRadius;
    border-style: solid;
    border-color: $color-demure;
    outline: 0;
    transition: .2s ease all;
    height: auto;
    display: inline-flex;
    font-size: $fontSize-normal;
    padding: .25em 1em;
    min-height: 41px;

    &:hover {
      transition: .2s ease all;
      border-color: $color-main;
    }
  }

  ::v-deep .bx--text-input {
    @include input-container;
  }

  ::v-deep .bx--label {
    margin: 0;
  }

  ::v-deep .bx--file {
    width: auto;
  }

  .is-secondary {
    ::v-deep .bx--file__drop-container {
      background: $color-almost-white;
      text-decoration: none;
    }
  }

  .is-menu {
    flex-direction: row;

    &::before {
      content: "";
      background: url('../../assets/img/image.svg');
      background-size: 22px;
      background-repeat: no-repeat;
      width: 30px;
      height: 20px;
      margin-right: $unit-1;
      box-sizing: border-box;
    }

    ::v-deep
    .bx--file__drop-container {
      min-height: 0;
      padding: 0;
    }

    ::v-deep
    .bx--file--label,
    .bx--file--description {
      display: none;
    }

    ::v-deep
    .bx--label-description {
      display: none;
    }

    ::v-deep
    .bx--file__drop-container {
      border: none;
    }

    ::v-deep
    .bx--file {
      width: 100%;
    }

    &:hover {
      &::before {
        content: "";
        background: url('../../assets/img/image--active.svg');
        background-size: 22px;
        background-repeat: no-repeat;
        width: 30px;
        height: 20px;
        margin-right: $unit-1;
        box-sizing: border-box;
      }
    }
  }

  .is-file {
    &::before {
      content: "";
      background: url('../../assets/img/paperclip.svg');
      background-size: 22px;
      background-repeat: no-repeat;
      width: 30px;
      height: 20px;
      margin-right: $unit-1;
      box-sizing: border-box;
    }
    &:hover {
      &::before {
        content: "";
        background: url('../../assets/img/paperclip--active.svg');
        background-size: 22px;
        background-repeat: no-repeat;
        width: 30px;
        height: 20px;
        margin-right: $unit-1;
        box-sizing: border-box;
      }
    }
  }

</style>
